import React from 'react';
import './Hint.css';

function Hint({ onClose, hint }) {
  return (
    <div className='dialogbackground' onClick={onClose}>
      <div className='hintdialog'>
        <div className='hintheader'>Here’s a hint!</div>
        <div className='hint'>
          <div className='hintcause'>
            {
              hint.requirementIds.map((requirementId, i) =>
                <React.Fragment key={i}>
                  { i !== 0 && <div className='hintsymbol'><div className='text'>+</div></div> }
                  <div className='hintrequirement'>
                    <img alt="" src={require(`./images/${requirementId}.svg`).default}></img>
                  </div>
                </React.Fragment>
              )
            }
          </div>
          <div className='hintdivider'>&#8658;</div>
          <div className='hinteffect'>
            <div className='hintresult'>
              <img alt="" src={require(`./images/question-mark.svg`).default}></img>
            </div>
          </div>
        </div>
        <div className='logreminder'>Find these again in the log book <img alt="Log" title="Log" src={require(`./images/log.svg`).default} /></div>
      </div>
    </div>
  );
}

export default Hint;
